import React, { useState } from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import { useTranslation } from 'react-i18next';

import validators from '../../../utils/validators';

import useStyles from './BaseInputLongitude.styles';

const propTypes = {
    label: PropTypes.string,
    onChange: PropTypes.func.isRequired
};

const defaultProps = {
    label: 'longitude'
};

const BaseInputLongitude = ({ label, onChange, ...rest }) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const [error, setError] = useState('');

    const handleChange = e => {
        if (!validators.floatRegex.test(e.target.value) || parseFloat(e.target.value) > 90 || parseFloat(e.target.value) < -90) {
            setError('invalidLongitude');
        } else {
            setError('');
        }

        onChange(e);
    };

    return (
        <TextField
            {...rest}
            required
            key="longitude"
            label={t(label)}
            InputLabelProps={{
                shrink: true
            }}
            placeholder="-8.4292057"
            helperText={t(error)}
            error={error !== ''}
            onChange={handleChange}
            InputProps={{
                classes: {
                    root: classes.rootDefaultInput
                }
            }}
        />
    );
};

BaseInputLongitude.propTypes = propTypes;
BaseInputLongitude.defaultProps = defaultProps;

export default BaseInputLongitude;
